import React, { useState } from 'react';
import '../styles/Home.css';
import Booking from './Booking';

const HomeFinance = () => {
  const [bookpopup, setBookPopup] = useState(false);

  const handleClick = () => {
    setBookPopup(true);
  };

  const handleClose = () => {
    setBookPopup(false);
  };

  return (
    <div>
      <div className="tax-continer">

        {/* first container */}
        <div className="tax-container-first"></div>

        {/* second container */}
        <div className="tax-container-second">
          <h1 className="taxt-head">Unlock Your Financial Potential</h1>

          <p className="tax-para">
            At our Taxtimez services, we understand the complexities 
            of the tax landscape and are dedicated to providing our clients with 
            personalized guidance and innovative strategies they need to achieve 
            their financial goals.
          </p>

          {/* ✅ Open Popup on Click */}
          <button className="tax-button" onClick={handleClick}>
            Schedule a consultation
          </button>

          {/* ✅ Popup Modal */}
          {bookpopup && <Booking isOpen={bookpopup} onClose={handleClose} />}
        </div>
      </div>
    </div>
  );
};

export default HomeFinance;
